import React from "react";
import "../../../../css/Marketing/FinancialPromotions/Buttons/RiskPill.css";

const normalizeRisk = (risk) => {
  const normalized = String(risk || "")
    .trim()
    .toLowerCase();

  if (normalized === "med") return "medium";
  if (["high", "medium", "low", "processing", "unknown"].includes(normalized)) {
    return normalized;
  }

  return "unknown";
};

const toDisplayRisk = (normalizedRisk) => {
  if (normalizedRisk === "unknown") return "Unknown";
  return normalizedRisk.charAt(0).toUpperCase() + normalizedRisk.slice(1);
};

export default function RiskPill({ risk, className = "" }) {
  const normalizedRisk = normalizeRisk(risk);
  const displayRisk = toDisplayRisk(normalizedRisk);

  return (
    <span
      className={`fp-risk-pill fp-risk-pill--${normalizedRisk} FP_Content_Semibold ${className}`.trim()}
    >
      {displayRisk}
    </span>
  );
}
